import React, { useState } from 'react';
import {Carousel} from 'react-responsive-carousel'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
import '../css/carousel.css'
//@use 'styles/_colors.scss'; // assuming a styles directory under src/
//@use '~react-responsive-carousel/carousel'; // loading a css file from the nprogress node module
//var Carousel = require('react-responsive-carousel').Carousel;
const SJCarouselDyna = (props) => {
   
    const {roomImgs} = props
    
   const onChange = (o) =>{
       console.log('onChange called')
      

   }
   const onClickItem = (o) =>{
    console.log('onClickItem called')
   

}

const onClickThumb = (o) =>{
    console.log('onClickThumb called')
    

}

    return (
        <Carousel showThumbs={false} showArrows={true} onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}>
            {
                roomImgs.map( (obsj,idx)=>{
                    return (
                    <div>
                        <img  src={`${obsj}`} alt="Carpet Grass" />
                          
                        
                      </div>
                    )
                })
            }
           
        </Carousel>
    );

    

}

export default SJCarouselDyna;